import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';
import { projectNumber } from '../../app/core/index';
import { ThemeService, AuthService } from '../../providers/index';

@Component({
  selector: 'page-project-number-generator',
  templateUrl: 'project-number-generator.html'
})
export class ProjectNumberGeneratorPage {

  projectNumber: projectNumber = new projectNumber();
  projectID: string;
  public project: string;

  constructor(public navCtrl: NavController,
              private _theme: ThemeService,
              private _auth: AuthService)
  {
    this.project = this._theme.getTitle();
  }

  createProjectNumber(date, number ): void {
   this.projectID = this.projectNumber.getProjectNo(date, number);
  }

  ionViewCanEnter(): boolean {
    if (this._auth.authenticated) {
      return true;
    } else {
      return false;
    }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ProjectNumberGeneratorPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/project-number-generator/project-number-generator.ts